const minHeight = typeof window !== "undefined" && window.innerHeight;
const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: "100vh",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2
  },
  block: {
    display: "block"
  },
  modal: {
    // minHeight: 600,
    minWidth: 600,
    maxWidth: minWidth / 1.5
  },
  form: {
    height: 430,
    overflowY: "auto"
  },
  form_inner: {
    overflowY: "auto"
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    minWidth: 40,
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  fileUpload: {
    color: "#1C408C!important",
    fontWeight: "bold"
  },
  import: {
    backgroundColor: theme.palette.accent,
    color: "white",
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: "#fd5622"
    },
    marginTop: "25px"
  },
  tooltip: {
    color: "#1C408C",
    fontWeight: "bold",
    marginLeft: "20px",
    display: "inline-table",
    paddingTop: "18px",
    verticalAlign: "middle"
  },
  uploadValidation: {
    color: "red",
    paddingLeft: "20px",
    display: "inline-table",
    paddingTop: "18px",
    verticalAlign: "middle"
  },
  upload: {
    marginTop: "15px"
  },
  uploadlabel: {
    marginTop: "20px"
  },
  close: {
    padding: 0,
    minWidth: 40
  },
  testRange: {
    marginTop: 10,
    marginBottom: 10
  },
  listItem: {
    color: "red"
  },
  flex: {
    flex: 1
  },
  scrollableList: {
    maxHeight: 140,
    overflow: "auto",
    "& li": {
      "&:nth-child(odd)": {
        backgroundColor: "#F7F7F7"
      }
    }
  },
  summary: {
    padding: theme.spacing.unit
  },
  error: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#D42E4C",
    padding: 10,
    textAlign: "center",
    "& h3": {
      color: "white",
      fontSize: 18
    },
    "& p": {
      color: "white"
    }
  }
});

export default styles;
